/* lib/academy/playerParams.js — строка запроса плеера курса (?lesson=, ?purchase=).
 *
 * ПОЧЕМУ отдельным модулем, а не двумя строчками внутри CoursePlayer.
 *
 * Возврат с оплаты писали в адрес ДВА независимых эффекта одного коммита:
 * resume-эффект дописывал `&lesson=<id>`, а сторож post-purchase-окна снимал
 * `?purchase=`. Функциональная форма `setParams((prev) => …)` здесь не спасает:
 * в нашем history-шиме (lib/router.jsx) `prev` собирается из `location.search`,
 * ЗАМКНУТОГО на рендер, в котором колбэк создан. Второй писатель коммита видел
 * адрес ДО первого, и `?purchase=abc&lesson=161` схлопывался в пустую строку —
 * заплативший ученик получал экран «Выберите урок» (воспроизведено живым
 * прогоном на 380 и 1740, оракул /root/pw/QA2_bug_lessonparam.mjs).
 *
 * Живой источник правды — `window.location.search`: шим пишет адрес через
 * pushState/replaceState СИНХРОННО внутри navigate, поэтому сразу после первого
 * писателя он уже содержит `lesson=161`, тогда как React-состояние роутера
 * обновится только следующим рендером. Отсюда правило экрана: считаем новую
 * строку от `liveSearch()`, а не от снимка.
 *
 * Функции чистые (строка → строка) — их можно проверить юнит-тестом без DOM.
 */

/** Живая строка запроса адресной строки (без React-состояния роутера).
 *  Вне браузера (тесты, SSR) — пустая строка. */
export function liveSearch() {
  return (typeof window !== 'undefined' && window.location && window.location.search) || '';
}

/** Строка запроса с выбранным уроком. Остальные параметры сохраняются. */
export function withLesson(search, lessonId) {
  const sp = new URLSearchParams(search || '');
  sp.set('lesson', String(lessonId));
  return sp.toString();
}

/** Строка запроса без служебных параметров возврата из платёжного шлюза.
 *  Всё остальное (в первую очередь уже выбранный `lesson`) остаётся на месте. */
export function withoutPurchase(search) {
  const sp = new URLSearchParams(search || '');
  sp.delete('purchase');
  sp.delete('failed');
  return sp.toString();
}
